export default "__VITE_ASSET__BLLecLYe__"